export interface IconProps {
  size?: number;
  fill?: string;
  className?: string;
}

const PlayFilledIcon = ({
  size = 16,
  fill = 'currentColor',
  className,
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="-0.5 0 7 7"
    width={size}
    height={size}
    fill={fill}
    className={className}
  >
    <path d="M5.494737 2.57322 1.500752.14219C.83208-.26458 0 .25002 0 1.06891v4.86204c0 .81995.83208 1.33349 1.500752.92672l3.993985-2.42996c.673684-.40997.673684-1.44452 0-1.85449" />
  </svg>
);

export default PlayFilledIcon;
